<!-- Product Variant Selection Component -->
<div class="product-variant-container">
    <!-- Iterate through product attributes -->
    @for (attribute of attributesMap | keyvalue: asIs; track attribute.key; let i = $index) {
    @switch (attribute.key) {
    @case (AttributeType.Color) {
    <div class="color-variations" role="group" [attr.aria-labelledby]="'color-label-' + i">
        <label id="color-label-{{ i }}" class="variant-label">Choose Color</label>

        <ul class="variation-list" role="list">
            @for (colorVariant of attribute.value | keyvalue: alphabetAndNumberAscOrder; track colorVariant.key) {
            <li class="variation-content" [class.variation-disabled]="isLoading" role="listitem">
                <button type="button" class="variation-list-item product-color" [class.active]="attributeSelections.get(attribute.key)?.value === colorVariant.key" [class.variant-name]="!colorVariant.value.featured_images[0]" [class.variation-disabled]="isLoading" (click)="goToProduct(attribute.key, colorVariant.key)" [title]="colorVariant.key" [attr.aria-label]="'Select ' + colorVariant.key + ' color'" [attr.aria-pressed]="attributeSelections.get(attribute.key)?.value === colorVariant.key" [disabled]="isLoading">
                    @if (colorVariant.value.featured_images[0]) {
                    <img [src]="colorVariant.value.featured_images[0].url" [alt]="colorVariant.key + ' color swatch'" class="variation-image" />
                    } @else {
                    <span class="color-text">{{ colorVariant.key }}</span>
                    }
                </button>
            </li>
            }
        </ul>
    </div>
    }
    @case (AttributeType.Size) {
    @if (attribute.value | keyvalue: keyAscOrder; as sizeVariants) {
    @if (getVariantKey(sizeVariants)) {
        <ng-container *ngTemplateOutlet="default; context: { $implicit: attribute, index: i }"></ng-container>
        } @else {
        <ng-container *ngTemplateOutlet="SIZE_VARIANT_COMMON_TEMPLATE; context: { $implicit: attribute, index: i }">
        </ng-container>
        }
        }
        }
        @case (AttributeType.SizeCM) {
        <ng-container *ngTemplateOutlet="SIZE_VARIANT_COMMON_TEMPLATE; context: { $implicit: attribute, index: i }"></ng-container>
        }
        @case (AttributeType.SizeUS) {
        <ng-container *ngTemplateOutlet="SIZE_VARIANT_COMMON_TEMPLATE; context: { $implicit: attribute, index: i }"></ng-container>
        }
        @case (AttributeType.SizeUK) {
        <ng-container *ngTemplateOutlet="SIZE_VARIANT_COMMON_TEMPLATE; context: { $implicit: attribute, index: i }"></ng-container>
        }
        @case (AttributeType.ApparelSize) {
        <ng-container *ngTemplateOutlet="APPAREL_SIZE_VARIANT_COMMON_TEMPLATE; context: { $implicit: attribute, index: i }"></ng-container>
        }
        @default {
        <ng-container *ngTemplateOutlet="default; context: { $implicit: attribute, index: i }"></ng-container>
        }
        }
        }
</div>

<!-- Size Variant Common Template -->
<ng-template #SIZE_VARIANT_COMMON_TEMPLATE let-attribute let-index="index">
    <div class="size-variations" role="group" [attr.aria-labelledby]="'size-label-' + index">
        <label [id]="'size-label-' + index" class="variant-label">
            @switch (attribute.key) {
            @case (AttributeType.Size) {
            <span>Select Size</span>
            }
            @case (AttributeType.SizeCM) {
            <span>Select Size (CM)</span>
            }
            @case (AttributeType.SizeUK) {
            <span>Select Size (UK)</span>
            }
            @case (AttributeType.SizeUS) {
            <span>Select Size (US)</span>
            }
            @case (AttributeType.ApparelSize) {
            <span>Select Size</span>
            }
            @default {
            <span>Select Size</span>
            }
            }
        </label>

        <ul class="variation-list" role="list">
            @for (sizeVariant of attribute.value | keyvalue: keyAscOrder; track sizeVariant.key) {
            <li class="variation-content" [class.variation-active]="attributeSelections.get(attribute.key)?.value === sizeVariant.key" [class.variation-disabled]="isLoading" [class.size-variants]="attribute.key === AttributeType.Size" role="listitem" (click)="goToProduct(attribute.key, sizeVariant.key)" [title]="sizeVariant.key" [attr.aria-label]="'Select size ' + sizeVariant.key">
                <span class="strike"></span>
                <p class="size-element">{{ sizeVariant.key }}</p>
            </li>
            }
            @if (allOptionsUnavailable && index === attributesMap.size - 1) {
            <li class="info-container" role="listitem">
                <div class="icon-container">
                    <img [src]="IMAGE_URLS.infoCircleDark" class="info-icon" alt="Information" />
                </div>
                <p class="info-msg">Sorry, no options are available.</p>
            </li>
            }
        </ul>
    </div>
</ng-template>

<!-- Apparel Size Variant Template -->
<ng-template #APPAREL_SIZE_VARIANT_COMMON_TEMPLATE let-attribute let-index="index">
    <div class="size-variations" role="group" [attr.aria-labelledby]="'apparel-size-label-' + index">
        <label [id]="'apparel-size-label-' + index" class="variant-label">Select Size</label>

        <ul class="variation-list" role="list">
            @for (sizeVariant of attribute.value | keyvalue: apparelSize; track sizeVariant.key) {
            <li class="variation-content" [class.variation-active]="attributeSelections.get(attribute.key)?.value === sizeVariant.key" [class.variation-disabled]="isLoading" role="listitem" (click)="goToProduct(attribute.key, sizeVariant.key)" [title]="sizeVariant.key" [attr.aria-label]="'Select apparel size ' + sizeVariant.key">
                <span class="strike"></span>
                <p class="size-element">{{ sizeVariant.key }}</p>
            </li>
            }
            @if (allOptionsUnavailable && index === attributesMap.size - 1) {
            <li class="info-container" role="listitem">
                <div class="icon-container">
                    <img [src]="IMAGE_URLS.infoCircleDark" class="info-icon" alt="Information" />
                </div>
                <p class="info-msg">Sorry, no options are available.</p>
            </li>
            }
        </ul>
    </div>
</ng-template>

<!-- Default Variant Template -->
<ng-template #default let-attribute let-index="index">
    <div class="default-variation-section" role="group" [attr.aria-labelledby]="'default-label-' + index">
        <label [id]="'default-label-' + index" class="variant-label">{{ attribute.key }}</label>

        <ul class="default-variation-list" role="list">
            @for (variant of attribute.value | keyvalue: alphabetAndNumberAscOrder; track variant.key) {
            <li class="variation-content" role="listitem">
                <button type="button" class="variation-list-item" [class.active]="attributeSelections.get(attribute.key)?.value === variant.key" [class.variation-disabled]="isLoading" (click)="goToProduct(attribute.key, variant.key)" [title]="variant.key" [attr.aria-label]="'Select ' + attribute.key + ' ' + variant.key" [attr.aria-pressed]="attributeSelections.get(attribute.key)?.value === variant.key" [disabled]="isLoading">
                    <span class="variant-text">{{ variant.key }}</span>
                </button>
            </li>
            }
            @if (allOptionsUnavailable && index === attributesMap.size - 1) {
            <li class="info-container" role="listitem">
                <div class="icon-container">
                    <img [src]="IMAGE_URLS.infoCircleDark" class="info-icon" alt="Information" />
                </div>
                <p class="info-msg">Sorry, no options are available.</p>
            </li>
            }
        </ul>
    </div>
</ng-template>